module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "value-show-with-link"
  }, [_c('router-link', {
    attrs: {
      "to": _vm.routeParams,
      "data-action": _vm.model + '.edit',
      "data-action-id": _vm.item.id
    }
  }, [_vm._v(_vm._s(_vm.value))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-db823be0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/helpers/DataDisplay/CollectionValues/CollectionValueShowWithEditLink.vue
// module id = 2002
// module chunks = 0